import React from "react";

import { useDictionary } from "hooks";
import { CAYUSE_TYPES } from "globals/constants";

import Integration from "./Integration";


function HaploEthicsMonitor (props) {
	const dictionary = useDictionary('haploEthicsIntegration');

	return <Integration title={dictionary.headline ?? 'Link to Ethics Monitor'} { ...props }/>;
}

HaploEthicsMonitor.showInPalette = () => true;

HaploEthicsMonitor.paletteInformation = () => ({
	id: "cayuseHaploEthicsMonitor",
	name: "Ethics Monitor Search",
	type: "cayuseHaploEthicsMonitor",
	group: "sponsoredProject"
});

HaploEthicsMonitor.newElement = () => ({
	designInfo: {
		stencilSuperIds: [
			"Component"
		],
		stencilId: "cayuse-haplo-ethics-monitor",
		customStencilId: "null"
	},
	type: CAYUSE_TYPES.HAPLO_ETHICS,
	cayuseShortLabel: "Ethics Monitor"
});

HaploEthicsMonitor.initialValue = "{{haploEthicsMonitor}}";


export default HaploEthicsMonitor;
